<template>
    <div>

        <div class="form-group" v-if="isOnAir">
            <label for="broadcast_title">{{ $t('words.title') }}</label>
            <div class="input-group">
                <input type="text" id="broadcast_title" name="title"
                       :class="{ 'form-control': true, 'is-invalid': meta.errors.title }" :disabled="!isModify" v-model="title"
                />
                <div class="input-group-append" v-if="haveSubmitRight">
                    <button class="btn btn-danger" v-if="isModify" @click.prevent="doCancel">
                        {{ $t('words.cancel') }}
                    </button>
                    <button class="btn btn-primary" @click.prevent="onEdit">
                        <template v-if="isModify">
                            {{ $t('words.store') }}
                        </template>
                        <template v-else>
                            {{ $t('words.edit') }}
                        </template>
                    </button>
                </div>
                <span class="invalid-feedback" v-if="meta.errors.title" v-for="error in meta.errors.title" :key="error">{{ error }}</span>
            </div>
        </div>
        <div class="form-group" v-else>
            <label for="meta_title_pattern">{{ $t('words.meta_title_pattern') }}</label>
            <div class="input-group">
                <input type="text" id="meta_title_pattern" name="title"
                       :class="{ 'form-control': true, 'is-invalid': meta.errors.meta_title_pattern }"
                       :disabled="!isModify" v-model="meta_title_pattern"
                />
                <div class="input-group-append" v-if="haveSubmitRight">
                    <button class="btn btn-danger" v-if="isModify" @click.prevent="doCancel">
                        {{ $t('words.cancel') }}
                    </button>
                    <button class="btn btn-primary" @click.prevent="onEdit">
                        <template v-if="isModify">
                            {{ $t('words.store') }}
                        </template>
                        <template v-else>
                            {{ $t('words.edit') }}
                        </template>
                    </button>
                </div>
                <span class="invalid-feedback" v-if="meta.errors.meta_title_pattern" v-for="error in meta.errors.meta_title_pattern" :key="error">{{ error }}</span>
            </div>

            <div class="form-guide-box">
                <p class="form-guide"><i class="icon icon-info-circle-line"></i>{{ $t('paragraphs.channel.meta_title_pattern.sample_desc') }}</p>
                <ul>
                    <li>{{ $t('paragraphs.channel.meta_title_pattern.sample1') }}</li>
                    <li>{{ $t('paragraphs.channel.meta_title_pattern.sample2') }}</li>
                    <li>{{ $t('paragraphs.channel.meta_title_pattern.sample3') }}</li>
                    <li>{{ $t('paragraphs.channel.meta_title_pattern.sample4') }}</li>
                    <li>{{ $t('paragraphs.channel.meta_title_pattern.sample5') }}</li>
                </ul>
            </div>
        </div>
        <div class="form-group">
            <label for="meta_description" v-if="isOnAir">{{ $t('words.description') }}</label>
            <label for="meta_description" v-else>{{ $t('words.meta_description') }}</label>
            <div :class="{'form-group': true, 'has-error':meta.errors.meta_description}">
                <textarea id="meta_description" name="meta_description" rows="2"
                          :class="{'form-control':true, 'is-invalid':meta.errors.meta_description}"
                          :disabled="!isModify"
                          v-model="meta_description"></textarea>
                <span class="invalid-feedback" v-if="meta.errors.meta_description" v-for="error in meta.errors.meta_description" :key="error">{{ error }}</span>
            </div>
        </div>
        <div class="form-group">
            <template v-if="channel.is_shared">
                <label class="form-title" for="vg_link">{{ $t('words.video_gateway_link') }}</label>
                <div class="input-group input-group-flat">
                    <div class="input-group-prepend">
                        <span class="input-group-text">{{ $t('words.link') }}</span>
                    </div>
                    <input class="form-control" type="text" id="vg_link" disabled v-model="channel.video_gateway_url">
                    <div class="input-group-append">
                        <button class="btn btn-secondary  clipboard-copy" v-clipboard:copy="channel.video_gateway_url" v-clipboard:success="onCopy" v-clipboard:error="onCopyError">{{ $t('words.copy') }}</button>
                    </div>
                </div>
            </template>
            <template v-else>
                <label class="form-title" for="channel_key">{{ $t('words.channel_key') }}</label>
                <div class="input-group input-group-flat">
                    <div class="input-group-prepend">
                        <span class="input-group-text">{{ $t('words.link') }}</span>
                    </div>
                    <input class="form-control" type="text" id="channel_key" disabled v-model="channel.key">
                    <div class="input-group-append">
                        <button class="btn btn-secondary  clipboard-copy" v-clipboard:copy="channel.key" v-clipboard:success="onCopy" v-clipboard:error="onCopyError">{{ $t('words.copy') }}</button>
                    </div>
                </div>
            </template>
        </div>
        <div class="form-group">
            <template>
                <label class="form-title" for="vg_link">{{ $t('words.video_gateway') }}</label>
                <div class="form-inline">
                    <div class="form-checkbox">
                        <input type="checkbox" v-model="channel.show_channel_title_at_vg" id="show-channel-title-at-vg">
                        <label for="show-channel-title-at-vg">{{ $t('words.show_channel_title_at_vg')}}</label>
                    </div>
                    <div class="form-checkbox">
                        <input type="checkbox" v-model="channel.show_broadcast_title_at_vg" id="channel-show-broadcast-title-at-vg">
                        <label for="channel-show-broadcast-title-at-vg">{{ $t('words.show_broadcast_title_at_vg')}}</label>
                    </div>
                    <div class="form-checkbox">
                        <input type="checkbox" v-model="channel.show_meta_description_at_vg" id="channel-show_meta_description-at-vg">
                        <label for="channel-show_meta_description-at-vg">{{ $t('words.show_meta_description_at_vg')}}</label>
                    </div>
                    <button class="btn btn-primary btn-show-at-vg" @click.prevent="onVgAttrUpdate">
                        {{ $t('words.store') }}
                    </button>
                </div>

            </template>
        </div>
        <div class="form-group" v-if="!programChannel">
            <label class="form-title" for="appleication_uri">{{ $t('words.application') }}</label>
            <div class="input-group input-group-flat">
                <div class="input-group-prepend">
                    <span class="input-group-text">{{ $t('words.link') }}</span>
                </div>
                <input class="form-control" type="text" id="appleication_uri" disabled v-model="channel.publish_url">
                <div class="input-group-append">
                    <button class="btn btn-secondary  clipboard-copy" v-clipboard:copy="channel.publish_url" v-clipboard:success="onCopy" v-clipboard:error="onCopyError">{{ $t('words.copy') }}</button>
                </div>
            </div>
        </div>
        <div class="form-group" v-if="isOnAir && !programChannel">
            <label class="form-title sr-only" for="creator_stream_key">{{ $t('words.stream_key') }}</label>
            <div class="input-group input-group-flat">
                <div class="input-group-prepend">
                    <span class="input-group-text">{{ $t('words.stream_key') }}</span>
                </div>
                <input class="form-control" type="text" id="creator_stream_key" disabled v-model="channel.latest_live_media_broadcast.live_creator.stream_key">
                <button class="btn btn-secondary  clipboard-copy"  v-clipboard:copy="channel.latest_live_media_broadcast.live_creator.stream_key" v-clipboard:success="onCopy" v-clipboard:error="onCopyError">{{ $t('words.copy') }}</button>
            </div>
        </div>
        <!--<p v-else>-->
            <!--{{ $t('paragraphs.channel.it_is_not_on_air') }}-->
        <!--</p>-->
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import GlobalConfigMixin from '../../mixin/GlobalConfigMixin';
import ChannelStatusMixin from '../../mixin/ChannelStatusMixin';
import ChannelConfig from './ChannelConfig';

export default {
    props: {
        channel: {
            type: [Object],
            require: true,
        },
    },
    mixins: [
        GlobalConfigMixin,
        ChannelStatusMixin,
    ],
    data() {
        return {
            isModify: false,
            old_title: null,
            old_meta_description: null,
            old_meta_title_pattern: null,
            title: null,
            meta_title_pattern: null,
            meta_description: null,
            meta: {
                errors: {},
            },
        };
    },
    methods: {
        initialize() {
            this.title = this.channel.latest_live_media_broadcast.title;
            this.meta_title_pattern = this.channel.meta_title_pattern;
            this.meta_description = this.channel.meta_description;

            this.meta.errors = {};
        },
        rollbackData() {
            this.title = this.old_title;
            this.meta_description = this.old_meta_description;
            this.meta_title_pattern = this.old_meta_title_pattern;
        },
        doCancel() {
            this.isModify = false;
            this.rollbackData();
        },
        onEdit() {
            if (this.isModify) {
                this.doUpdate();
            } else {
                this.isModify = !this.isModify;
                this.old_title = this.title;
                this.old_meta_description = this.meta_description;
                this.old_meta_title_pattern = this.meta_title_pattern;
            }
        },
        onVgAttrUpdate() {
            if (!this.haveSubmitRight) {
                return;
            }
            axios.patch(this.channelApiPath, {
                show_channel_title_at_vg: this.channel.show_channel_title_at_vg,
                show_broadcast_title_at_vg: this.channel.show_broadcast_title_at_vg,
                show_meta_description_at_vg: this.channel.show_meta_description_at_vg,
            }).then(() => {
                this.$toasted.success(this.$t('paragraphs.message.success.change'));
            }).catch((error) => {
                this.meta.errors = error.response.data.errors;
                this.$toasted.error(this.$t('paragraphs.message.error.change'));
            });
        },
        doUpdate() {
            if (!this.haveSubmitRight) {
                return;
            }
            if (this.isOnAir) {
                axios.patch(this.broadcastApiPath, {
                    title: this.title,
                }).then(() => {
                    axios.patch(this.channelApiPath, {
                        meta_description: this.meta_description,
                    }).then(() => {
                        this.isModify = false;
                        this.$toasted.success(this.$t('paragraphs.message.success.change'));
                    }).catch((error) => {
                        this.meta.errors = error.response.data.errors;
                        this.$toasted.error(this.$t('paragraphs.message.error.change'));
                    });
                }).catch((error) => {
                    // TODO : array push
                    this.meta.errors = error.response.data.errors;
                    this.$toasted.error(this.$t('paragraphs.message.error.change'));
                });
            } else {
                axios.patch(this.channelApiPath, {
                    meta_title_pattern: this.meta_title_pattern,
                    meta_description: this.meta_description,
                }).then(() => {
                    this.isModify = false;
                    this.$toasted.success(this.$t('paragraphs.message.success.change'));
                }).catch((error) => {
                    this.meta.errors = error.response.data.errors;
                    this.$toasted.error(this.$t('paragraphs.message.error.change'));
                });
            }
        },
        /**
         * doCopy
         *
         * @param {string} copyText
         * @return void
         */
        doCopy(copyText) {
            this.$copyText(copyText).then(() => {
                this.$toasted.success(this.$t('paragraphs.copied_clipboard'));
            });
        },
        onCopy(e) {
            this.$toasted.success(this.$t('paragraphs.copied_clipboard'));
        },
        onCopyError(e) {
            console.log(e);
        },
        changeChannel(data) {
            this.$emit('changeChannel', data);
        },
    },
    computed: {
        channelApiPath() {
            return `/cms/${this.selectedServiceAccount.key}/channels/${this.channel.id}`;
        },
        broadcastApiPath() {
            return `${this.channelApiPath}/broadcasts/${this.channel.latest_live_media_broadcast.id}`;
        },
        haveSubmitRight() {
            return this.haveManagerRight;
        },
        loadedChannel() {
            return this.loadedServiceAccount && ('id' in this.channel) && (this.channel.id !== '');
        },
    },
    watch: {
        loadedChannel(newValue) {
            if (newValue) {
                this.initialize();
            }
        },
        isOnAir(newValue) {
            this.initialize();
        },
    },
};

</script>
<style>
.input-group-flat .input-group-text {
    width: 72px;
}
</style>
